import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { parseQs } from 'helpers/http';
import List from 'components/List';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import ListFilterCompany from 'components/layout/list/filters/ListFilterCompany';
import ListFilterReset from 'components/layout/list/ListFilterReset';
import CommissionServiceInvoicesList from 'components/layout/financial/CommissionServiceInvoicesList';
import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import may from 'js/security';
import { ROLE_ROOT_EMPLOYEE } from 'js/constants';
import {Button, Table} from "react-bootstrap";
import Axios from "axios";
import {confirmAlert} from "react-confirm-alert";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import _, { findIndex as _findIndex, forEach as _forEach, sortBy } from 'lodash';
import FormSwitchery from "components/forms/FormSwitchery";
import {deleteProductGroupR, setProductGroupStatusR} from "actions/ListActions";
import ClientSubscriptionNew from "components/layout/subscriptions/ClientSubscriptionNew";
import ClientSubscriptionEdit from "components/layout/subscriptions/ClientSubscriptionEdit";
import SimplePrompt from "components/layout/SimplePrompt";
import ProductGroupsNew from "components/layout/ProductGroups/ProductGroupsNew";
import ProductGroupsEdit from "components/layout/ProductGroups/ProductGroupsEdit";


class ProductGroupsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNew: false,
      showEdit:false,
      productGroupId: "",
    };
  }



  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;



    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.product_groups },
        ]}
        className="p-t-0"
      />
    );
  };

  setStatus = (name, value, id) => {
   let data = {
      isActive: value
    }
    this.props.setProductGroupStatusR(data, id);
  }

  showProductGroupsNew = () => {
    this.setState({ showNew: true });
  }

  closeProductGroupsNew = () => {
    this.setState({ showNew: false });
  };

  showProductGroupsEdit = (id) => {
    this.setState({productGroupId: id}, () => {
      this.setState({ showEdit: true });
    })

  }

  closeProductGroupsEdit = () => {
    this.setState({ showEdit: false });
  };

  deleteProductGroup = (id) => {
    this.props.deleteProductGroupR(id)
  }

  render() {
    const {
      intl: { messages },
      list,
      user,
      location,
    } = this.props;

    const { printing } = this.state;
    const query = parseQs(location.search);

    const urlData = {
      filters: {
        target: query.target,
      },
    };
    const columns = [messages.product_group_number, messages.product_group_status , messages.product_group_actions];
    const tBody = [];
    _forEach(list.data.list, (productGroup, index) => {
      tBody.push(
        <tr key={index} className="clickable" onClick={() => {}}>
          <td className="v-align-middle">
            <span>{productGroup.number}</span>
          </td>
          <td className="v-align-middle">
            <FormSwitchery
              name="status"
              label=""
              value
              checked={productGroup.is_active}
              onChange={(name, value) => this.setStatus(name, value, productGroup.id)}
              disabled=""
            />
          </td>
          <td className="v-align-middle" style={{textAlign:"right"}}>
            <Button
              onClick={() => this.showProductGroupsEdit(productGroup.id)}
              bsStyle="warning"
              className="pull-right m-l-5 m-t-5 m-b-5"
              title={messages.edit_product_group}
            >
              <i className="far fa-edit" />
              <span className="hidden-xs"> {messages.edit_product_group}</span>
            </Button>
            <SimplePrompt className="m-l-5 m-t-5 m-b-5"
                          onSuccess={e => this.deleteProductGroup(productGroup.id)}
            />
          </td>
        </tr>)
    })



    return (
      <>
        <List
          listName="productGroups"
          url="/api/flyeralarm/productgroups/list/fa/product/groups.json"
          urlData={urlData}
          list={list}
          title={messages.product_groups}
          iconClass="fal fa-file-alt"
          showNew={true}
          newText={messages.new_product_group}
          newAction={this.showProductGroupsNew}
          showSearch
          sortOptions={['cdate,desc']}
          breadcrumb={this.getBreadcrumb()}
        >


          {list.pending || this.props.pending ? (
            <Loader />
          ) : (
            <Table responsive hover>
              <thead>
              <tr>
                {columns.map((column, i) => {
                  return (
                    <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                      {column}
                    </th>
                  );
                })}
              </tr>
              </thead>
              <ReactCSSTransitionGroup
                transitionName="tablerows"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={1}
                component="tbody"
              >

                {tBody}
              </ReactCSSTransitionGroup>
            </Table>
          )}
          <div id="product-group-new">
            <ProductGroupsNew show={this.state.showNew} close={this.closeProductGroupsNew} />
          </div>


        <div id="product-group-edit">
          <ProductGroupsEdit show={this.state.showEdit} close={this.closeProductGroupsEdit} productGroupId={this.state.productGroupId}/>
        </div>

        </List>


        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.productGroups,
    user: state.login.user,
    pending: state.list.productGroups.pendingProductGroup
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setProductGroupStatusR: (data, id) => {
      dispatch(setProductGroupStatusR(data, id));
    },
    deleteProductGroupR: (id) => {
      dispatch(deleteProductGroupR(id));
    },
  };

};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProductGroupsList)));
